<div class="ui basic segment page-container centered" [class.loading]="isLoading">
    <div>
        <app-header title="{{ 'time-tracking.enterHoursPage.enterHoursForEmployees' | appTranslate }}" [back]="true">
        </app-header>
        <app-enter-hours-list
            *ngIf="hasLoadedData"
            [timesheetEntries]="timesheetEntries"
            [employees]="employees"
            enteringFor="many"
            (onSave)="onSave()"
            [overlapErrors]="overlapErrors"
        ></app-enter-hours-list>
    </div>
</div>
